/**
 * Question card attachment cloud upload status options
 */
export enum AttachmentCloudUploadStatus {
    /**
     * Attachment newly inserted and upload url has not been generated
     */
    NewlyInserted = 'new-inserted',
    
    Downloaded = 'downloaded',
    DownloadedUrlCreated = 'download-url-created',
    DownloadedFailed = 'download-failed',
    /**
     * Attachment upload url has been generated but not uploaded yet
     */
    UploadUrlCreated = 'upload-url-created',
    
    /**
     * Attachment upload completed successfully
     */
    Uploaded = 'uploaded',
    
    /**
     * upload failed
     */
    Failed  = 'upload-failed'
}